import React, { useEffect } from "react";
import { AiOutlineClose } from "react-icons/ai";

function ImageModal({ src, alt, onClose }) {
  useEffect(() => {
    const handleEscape = (event) => {
      if (event.key === "Escape") {
        onClose();
      }
    };

    // Add event listener when modal opens
    document.addEventListener("keydown", handleEscape);

    // Cleanup event listener when modal closes
    return () => {
      document.removeEventListener("keydown", handleEscape);
    };
  }, [onClose]);

  if (!src) return null;

  return (
    <div className="image-modal-overlay" onClick={onClose}>
      <div className="image-modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="image-modal-close" onClick={onClose} aria-label="Close">
          <AiOutlineClose />
        </button>
        <img src={src} alt={alt} className="image-modal-img" />
        {alt && <p className="image-modal-caption">{alt}</p>}
      </div>
    </div>
  );
}

export default ImageModal;